import { render, staticRenderFns } from "./InterfaceNetwork.vue?vue&type=template&id=0b74275a&scoped=true&"
import script from "./InterfaceNetwork.vue?vue&type=script&lang=js&"
export * from "./InterfaceNetwork.vue?vue&type=script&lang=js&"
import style0 from "./InterfaceNetwork.vue?vue&type=style&index=0&id=0b74275a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b74275a",
  null
  
)

export default component.exports